// extracted by mini-css-extract-plugin
export default {"userAvatarButton":"style_userAvatarButton__wOFSH","avatarCircle":"style_avatarCircle__GAglH","avatarContainer":"style_avatarContainer__E4UbS"};